import { Navigate, Route, Routes } from "react-router-dom";
import Layout from "../Layout/Layout";
import routes from "./Route";
import ticketCRoutes from "./TicketCRoutes";
import foodCRoutes from "./FoodCRoutes";
import cardAssignCRoutes from "./CardAssignCRoutes";
import cardRechargeCRoutes from "./CardRechargeCRoutes";
import clothCRoutes from "./ClothCRoutes";
import lockerCRoutes from "./LockerCRoutes";

const LayoutRoutes = () => {
  const role = JSON.parse(localStorage.getItem("user")!).role;
  const counterStatus = JSON.parse(localStorage.getItem("user")!).counterStatus;
  return (
    <Routes>
      { role === "Admin" && (
        <>
          {routes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      { role === "Staff" && (counterStatus === "Ticket Counter1" || counterStatus === "Ticket Counter2") && (
        <>
          {ticketCRoutes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      { role === "Staff" && counterStatus === "Food Counter" && (
        <>
          {foodCRoutes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      { role === "Staff" && counterStatus === "Card Assign" && (
        <>
          {cardAssignCRoutes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      { role === "Staff" && counterStatus === "Card Recharge" && (
        <>
          {cardRechargeCRoutes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      { role === "Staff" && counterStatus === "Cloth Counter" && (
        <>
          {clothCRoutes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      { role === "Staff" && counterStatus === "Locker Counter" && (
        <>
          {lockerCRoutes.map(({ path, Component }, i) => (
            <Route element={<Layout />} key={i}>
              <Route path={path} element={Component}/>
            </Route>
          ))}
        </>
      )}
      <Route path="*" element={<Navigate to={`${process.env.PUBLIC_URL}/dashboard/default`} replace />} />
    </Routes>
  );
};

export default LayoutRoutes;
